import '../generalMappings';
import { RootPage } from '../page';
import $api from '../../api';
import { TourModel, SegmentModel } from '../../models/Gen/TrackableBaseModels';
import * as siteConfig from '../../site-config/trackableConfig';
import languages from '../../utils/languages';
import RulesDescriptorComponent from '../../components/descriptors/rulesDescriptor';
import ConfirmationMessageDescriptor from '../../components/descriptors/confirmationMessageDescriptor';
import TourMinimizationDescriptorComponent from '../../components/descriptors/tourMinimizationDescriptor';
import Pager from '../../components/pager';
import { openEditor } from '../../common/editorUtils';
import { listenToPageDirty, resolvePageDirty, beginNoTracking, endNoTracking } from '../../utils/changeTracking';
import { isFlagOn, isInPricingPlan } from '../../utils/flags';
import SegmentationSelector from '../../components/segmentationSelector';
import ReactSegmentationSelector from '../../../react/descriptors-components/SegmenationSelector';
import { createDefaultRulesDescriptor } from '../../utils/core';
import ImportExport from "legacy/pages/imports-exports/importExport";

class TourDetailView extends RootPage {
    constructor() {
        super();

        Pager();
        RulesDescriptorComponent(this);
        ConfirmationMessageDescriptor(this);
        TourMinimizationDescriptorComponent(this);
        SegmentationSelector(this);

        //ReactSegmentationSelector(); // is this neccesary?
        this.ReactSegmentationSelector = ReactSegmentationSelector;

        this.isDirty = ko.observable(false);

        this.tour = ko.observable();
        this.allTours = ko.observable();

        this.setActiveTab('settings');

        this.editorOpen = ko.observable(false);

        this.languages = languages.sort((a, b) => (a.English > b.English) ? 1 : -1);
        this.selectedLanguageForAdd = ko.observable();
        this.selectedLanguageForAdd.subscribe(v => {
            if (v) {
                this.addSupportedLanguage(v);
            }
            this.selectedLanguageForAdd(null);
        });

        this.triggers = [
            { name: 'Once per user', type: 'onload', icon: 'fas fa-user fa-lg', pricingNote: false },
            { name: 'Always', type: 'always', icon: 'fas fa-sync-alt fa-lg', pricingNote: false },
            { name: 'Manually', type: 'manually', icon: 'fas fa-hand-paper fa-lg', pricingNote: false },
            { name: 'Scheduled', type: 'scheduled', icon: 'far fa-clock fa-lg', pricingNote: false }
        ];

        if (isFlagOn('tr_clck_trg')) {
            this.triggers.push({ name: 'On Element Clicked', type: 'onclicked', icon: 'fas fa-mouse-pointer fa-lg', pricingNote: false });
        }

        this.triggers.push({ name: 'Custom JavaScript', type: 'customjs', icon: 'fab fa-js-square', pricingNote: true });

        this.selectedTrigger = ko.computed({
            read: () => {
                if (this.tour() && this.tour().descriptorObject().triggers() && this.tour().descriptorObject().triggers().length > 0) {
                    var selType = ko.unwrap(this.tour().descriptorObject().triggers()[0].type);

                    return this.triggers.filter(i => i.type === selType)[0];
                } else {
                    return this.triggers[1]; // manually
                }
            },
            write: (val) => {
                if (!this.tour()) {
                    return;
                }

                if (!this.tour().descriptorObject()) {
                    return;
                }

                if (this.tour().descriptorObject().triggers()) {
                    this.tour().descriptorObject().triggers.removeAll();
                } else {
                    this.tour().descriptorObject().triggers([]);
                }
                this.tour().descriptorObject().triggers.push(val);
            }
        });

        this.scheduledTriggerOptions = ko.observable(new siteConfig.ScheduledTriggerOptions());
        this.onClickedTriggerOptions = ko.observable(new siteConfig.OnClickedTriggerOptions());

        this.segments = ko.observableArray();
        this.segmentationSelected = ko.observable();

        this.resetUsername = ko.observable();

        this.allSegmentsRaw = this.getServerSideData('segments');
        this.allToursRaw = this.getServerSideData('allTours');
        this.tourRaw = this.getServerSideData('tour');

        this.segmentRaw = ko.observable(this.tourRaw.segmentId);
        this.rulesRaw = ko.observable(this.tourRaw.descriptorObject ? this.tourRaw.descriptorObject.rules : []);
    }

    onSegmentationTypeChanged(type) {
        this.segmentRaw(null);
        this.rulesRaw(createDefaultRulesDescriptor());
        this.isDirty(true);
    }

    onSegmentSelected(segment) {
        this.segmentRaw(segment);
        this.isDirty(true);
    }

    onRulesSelected(rules) {
        this.rulesRaw(rules);
        this.isDirty(true);
    }

    onAllUsersSelected() {
        this.segmentRaw(null);
        this.rulesRaw(createDefaultRulesDescriptor());
        this.isDirty(true);
    }

    get tourDescriptorTrigger() {
        if (this.tour() && this.tour().descriptorObject().triggers() && this.tour().descriptorObject().triggers().length > 0) {
            return this.tour().descriptorObject().triggers()[0];
        }
    }

    onInit() {
        this.allTours(this.getServerSideData('allTours'));

        siteConfig.TourDescriptor.prototype._ModelExtender = function (model, p, pp, mappingOptions) {
            mappingOptions.confirmation = {
                create: function (options) {
                    return new siteConfig.ConfirmationMessageDescriptor(options.data);
                }
            };
            mappingOptions.minimization = {
                create: function (options) {
                    return new siteConfig.TourMinimizationDescriptor(options.data);
                }
            };
            mappingOptions.rules = {
                create: function (options) {
                    return new siteConfig.RulesDescriptor(options.data);
                }
            };
        };
        TourModel.prototype._ModelExtender = function (model, p, pp, mappingOptions) {
            mappingOptions.descriptorObject = {
                create: function (options) {
                    return new siteConfig.TourDescriptor(options.data);
                }
            };
        };

        this.tour(new TourModel(this.getServerSideData('tour')));

        if (this.tourDescriptorTrigger) {
            const trigger = ko.unwrap(this.tourDescriptorTrigger);

            if (ko.unwrap(trigger.type) == 'scheduled') {
                this.scheduledTriggerOptions(new siteConfig.ScheduledTriggerOptions(ko.unwrap(trigger.options)));
            } else if (ko.unwrap(trigger.type) == 'onclicked') {
                this.onClickedTriggerOptions(new siteConfig.OnClickedTriggerOptions(ko.unwrap(trigger.options)));
            }
        }

        beginNoTracking(this.scheduledTriggerOptions());
        if (!ko.unwrap(this.scheduledTriggerOptions().eachDays)) {
            this.scheduledTriggerOptions().eachDays(30);
        }
        if (!ko.unwrap(this.scheduledTriggerOptions().maxStateCounter)) {
            this.scheduledTriggerOptions().maxStateCounter(3);
        }
        endNoTracking(this.scheduledTriggerOptions());

        for (const segment of this.getServerSideData('segments')) {
            this.segments.push(new SegmentModel(segment));
        }

        listenToPageDirty((ev) => {
            if (ev.fieldName == 'TourModel.lastUpdatedAt') return;
            if (ev.fieldName == 'TourModel.publishStatus') return;

            this.isDirty(true);
        })

        $(document).on('input', '.change-track', (e) => {
            this.isDirty(true);
        });
    }

    importExport() {
        this.showDialog(ImportExport(this), {
            entityTypeName: 'tour', entityId: this.tour().id(), doneCallback: () => {
                window.location.reload();
            }
        });
    }

    deleteTour() {
        if (confirm('Really?')) {
            this.startSubmitting('delete');

            $api.tours.delete(
                { projectCode: auth.project.UniqueCode, id: this.tour().id() },
                {},
                () => {
                    this.stopSubmitting('delete');
                    window.location.href = '/' + auth.project.UniqueCode + '/tours/overview';
                }
            );
        }
    }

    addSupportedLanguage(l) {
        this.tour().supportedLanguages.push(l.alpha2);
    }

    removeSupportedLanguage(item) {
        this.tour().supportedLanguages.remove(item);
    }

    saveSettings(callback) {
        var jsTour = this.tour().toJS();
        var tourCopy = JSON.parse(JSON.stringify(jsTour));

        tourCopy.descriptorObject = null;

        tourCopy.segmentId = this.segmentRaw();

        var trigger = jsTour.descriptorObject.triggers && jsTour.descriptorObject.triggers.length > 0 ?
            jsTour.descriptorObject.triggers[0] : null;
        var rules = jsTour.descriptorObject.rules;
        var confirmation = jsTour.descriptorObject.confirmation;
        var minimization = jsTour.descriptorObject.minimization;

        if (trigger && trigger.type == 'scheduled') {
            const sch = this.scheduledTriggerOptions().toJS();
            trigger.options = { eachDays: sch.eachDays, until: sch.until, maxStateCounter: sch.maxStateCounter };
        } else if (trigger && trigger.type == 'onclicked') {
            const sch = this.onClickedTriggerOptions().toJS();
            trigger.options = { oneTime: sch.oneTime, selector: sch.selector };
        } else {
            trigger.options = null;
        }

        this.startSubmitting('saveSettings');
        $api.tours.save(
            { projectCode: auth.project.UniqueCode, id: this.tour().id() },
            { tour: tourCopy, trigger: trigger, rules: this.rulesRaw() /*rules*/, confirmation: confirmation, minimization: minimization },
            (resp) => {
                this.stopSubmitting('saveSettings');
                this.showToast('Saved.');
                this.isDirty(false);
                resolvePageDirty();
                this.tour().publishStatus(resp.publishStatus);
                typeof callback === 'function' && callback();
            }
        );
    }

    restartTour() {
        if (confirm('Really?')) {
            this.startSubmitting('restart');
            $api.tours.restart(
                { projectCode: auth.project.UniqueCode, id: this.tour().id() },
                {},
                (resp) => {
                    this.stopSubmitting('restart');
                    this.showToast('Tour restarted.');
                }
            );
        }
    }

    restartTourForUser(e) {
        if (confirm('Really?')) {
            this.startSubmitting('restart-for-user');
            $api.tours.restartForUser(
                { projectCode: auth.project.UniqueCode, id: this.tour().id(), username: encodeURIComponent(this.resetUsername()) },
                {},
                (resp) => {
                    this.stopSubmitting('restart-for-user');
                    this.showToast('Tour restarted for the given user.');
                }
            );
        }
    }

    publish(callback) {
        this.startSubmitting('publishCheck');

        $api.tours.publish(
            { projectCode: auth.project.UniqueCode, id: this.tour().id() },
            {},
            resp => {
                this.stopSubmitting('publishCheck');

                this.tour().publishStatus(resp.publishStatus);

                typeof callback === 'function' && callback();

                TRACK_EVENT('Tours', 'Published');
            }
        );
    }

    unpublish() {
        this.startSubmitting('unpublish');
        $api.tours.unpublish(
            { projectCode: auth.project.UniqueCode, id: this.tour().id() },
            {},
            resp => {
                this.stopSubmitting('unpublish');
                this.tour().publishStatus(resp.publishStatus);
            }
        );
    }

    saveAndPublish() {
        this.startSubmitting('save_publish');
        this.saveSettings(() => {
            this.publish(() => {
                this.stopSubmitting('save_publish');
            });
        });
    }

    editTour() {
        openEditor('tour', this.tour().baseUrl(), this.tour().id(), () => {
            this.editorOpen(false);
            $api.tours.get(
                { projectCode: auth.project.UniqueCode, id: this.tour().id() },
                {},
                resp => {
                    if (resp.lastUpdatedAt > this.tour().lastUpdatedAt()) {
                        TRACK_EVENT('Tours', 'Saved');
                    }
                    this.tour().lastUpdatedAt(resp.lastUpdatedAt);
                    this.tour().publishStatus(resp.publishStatus);
                }
            );
        });

        this.editorOpen(true);

        TRACK_EVENT('Tours', 'Editor opened', { from: 'detail' });
    }
}

export default TourDetailView;
